document.addEventListener('turbolinks:load', () => {
    $('#admin_user_roles').select2();
});
